import { create } from 'zustand'
import { persist } from 'zustand/middleware';
import Unknown from '../images/unknown.png'

export const useWalletStore = create(
    persist(
    (set) => ({
      
      address: '',
      chainId: '',
      network: '',
      pubKey: '',
      dappConnected: false,
      autoSign: false,
      currentWallet: {
        name: '',
        alias: '',
        icon: Unknown,
      },
      startWatch: false,
      walletDisconnected: false,
      button1: '',
      setButton1: (button1) => set({ button1 }),
      button2: '',
      setButton2: (button2) => set({ button2 }),
      button1Disabled: '',
      setButton1Disabled: (button1Disabled) => set({ button1Disabled }),
      button2Disabled: '',
      setButton2Disabled: (button2Disabled) => set({ button2Disabled }),

      setAddress: (address) => set({ address }),
      setChainId: (chainId) => set({ chainId }),
      setNetwork: (network) => set({ network }),
      setPublicKey: (pubKey) => set({ pubKey }),
      setDappConnected: (dappConnected) => set({ dappConnected }),
      setAutoSign: (autoSign) => set({ autoSign }),
      setWallet: (currentWallet) => set({ currentWallet }),
      setStartWatch: (startWatch) => set({ startWatch }),
      setWalletDisconnected: (walletDisconnected) => set({ walletDisconnected }),
    }),
    {
      name: 'wallet-storage', // name of the storage (must be unique),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(([key]) => !['startWatch', 'address'].includes(key))
        ),
    })
)